'use strict';

var novicell = novicell || {};

novicell.accordionReadMoreOnMobile =
    novicell.accordionReadMoreOnMobile ||
    (function() {
        var hoverIntentDelay = 300;
        function init() {
            var productSpecificationsAccordion = document.querySelectorAll('.base-accordion__header');
            if (productSpecificationsAccordion.length) {
                for (var i = 0; i < productSpecificationsAccordion.length; i++) {
                    productSpecificationsAccordion[i].addEventListener('click', function(e) {
                        accordionAnimate(this);
                    });
                }
            }
        }
        function accordionAnimate(element) {
            var parentItem = novicell.helpers.closestByClass(element, 'base-accordion');
            parentItem.classList.toggle('base-accordion--active');

            var contentContainer = parentItem.querySelector('.base-accordion__content');
            var elementContent = contentContainer.children[0];
            if (elementContent != undefined) {
                var style = window.getComputedStyle ? getComputedStyle(elementContent, null) : elementContent.currentStyle;

                var marginTop = parseInt(style.marginTop) || 0;
                var marginBottom = parseInt(style.marginBottom) || 0;
                var elementContentHeight = elementContent.offsetHeight + marginTop + marginBottom;
                var newHeight;
                var heightAttr = parentItem.dataset.height;

                if (heightAttr === undefined) {
                    newHeight = elementContentHeight;
                    parentItem.dataset.height = contentContainer.offsetHeight;
                } else {
                    if (heightAttr < contentContainer.offsetHeight) {
                        newHeight = heightAttr;
                    } else {
                        newHeight = elementContentHeight;
                    }
                }
                contentContainer.style.height = newHeight + 'px';

                var parentAccordion = novicell.helpers.closestByClass(parentItem, 'base-accordion');
                if (parentAccordion != null) {
                    var parentAccordionHeader = document.querySelector('.base-accordion--active .base-accordion__header');
                    setTimeout(function() {
                        recalcHeight(parentAccordionHeader);
                    }, hoverIntentDelay);
                }
            }
        }
        function recalcAll() {
            var productSpecificationsAccordion = document.querySelectorAll('.base-accordion--active .base-accordion__header');
            if (productSpecificationsAccordion.length) {
                for (var i = 0; i < productSpecificationsAccordion.length; i++) {
                    recalcHeight(productSpecificationsAccordion[i]);
                }
            }
        }
        function recalcHeight(element) {
            var parentItem = novicell.helpers.closestByClass(element, 'base-accordion');
            var contentContainer = parentItem.querySelector('.base-accordion__content');
            var elementContent = contentContainer.children[0];
            if (elementContent != undefined) {
                var style = window.getComputedStyle ? getComputedStyle(elementContent, null) : elementContent.currentStyle;

                var marginTop = parseInt(style.marginTop) || 0;
                var marginBottom = parseInt(style.marginBottom) || 0;
                var elementContentHeight = elementContent.offsetHeight + marginTop + marginBottom;
                var newHeight;
                newHeight = elementContentHeight;
                contentContainer.style.height = newHeight + 'px';
            }
        }

        return {
            init: init,
            recalcHeight: recalcHeight,
            recalcAll: recalcAll
        };
    })();
